export default __webpack_public_path__ + "static/media/checkedbox-icon.713d6177.png";